import { render } from "./ResultModal.vue?vue&type=template&id=aa7e7466&scoped=true"
import script from "./ResultModal.vue?vue&type=script&lang=js"
export * from "./ResultModal.vue?vue&type=script&lang=js"

import "./ResultModal.vue?vue&type=style&index=0&id=aa7e7466&scoped=true&lang=css"

import exportComponent from "/var/www/mobitel/quizgiri/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa7e7466"]])

export default __exports__